import { Component } from '@combos-fun/engine';
import { Field } from '@combos-fun/inspector-decorator';
import type { TextReplacements } from './localization';
import type { TextStyleInput } from './textStyle';

export type { TextReplacementValue, TextReplacements } from './localization';
export type { TextStyleInput } from './textStyle';

export interface TextParams {
  text: string;
  /** Values substituted into named placeholders such as `{score}`. */
  replacements?: TextReplacements;
  style?: TextStyleInput;
}

export default class Text extends Component<TextParams> {
  static componentName: string = 'Text';

  @Field({
    type: 'string',
    group: 'Text',
    label: 'text',
    description: 'Visible text content.',
    editor: 'text',
  })
  text: string = '';

  replacements: TextReplacements = {};

  // Complex style object — Scene Edit exposes leaf fields later if needed.
  style: TextParams['style'] = {};

  init(obj?: TextParams) {
    this.style = { fontSize: 20 };
    if (obj) {
      this.text = obj.text;
      this.replacements = { ...obj.replacements };
      Object.assign(this.style, obj.style);
    }
  }
}
